export const selectShiftGroupData = (state) => state.shiftGroup.shiftGroupData;
export const selectShiftGroupStatus = (state) => state.shiftGroup.status;
export const selectShiftGroupError = (state) => state.shiftGroup.error;
export const selectShiftData = (state) => state.shiftGroup.shiftData;
export const selectShiftMeta = (state) => state.shiftGroup.shiftMeta;
export const selectShiftGroupMeta = (state) => state.shiftGroup.meta
export const selectShiftById = (state) => state.shiftGroup.shiftById;
export const selectShiftGroupById = (state) => state.shiftGroup.shiftGroupById;
